function ComfortChart() {
    /// <summary>
    /// This object provides common functions for the ComfortChart-Visual <br />
    /// Author: GWA <br />
    /// Date: 15.10.2019 <br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History: <br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 15.10.2019                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.chart = null;
}
ComfortChart.prototype = new vcTemplate();
ComfortChart.prototype.init = function () {
    /// <summary>
    /// This function inits the calendar, the left menu and sets some heights.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }


        me.CHART_DATA_BORDER = {
            "Leisden&Freymark": { //Behaglichkeitsdiagramm Leisden & Freymark
                outer: {
                    name: me.resources.stillComfortable,
                    type: "area",
                    color: "rgb(255, 0, 0)",
                    lineColor: "rgb(255, 0, 0)",
                    data: [
                        [20, 20],
                        [17, 38],
                        [16, 75],
                        [17, 88],
                        [20.5, 82],
                        [25, 60],
                        [27, 30],
                        [25.5, 18],
                        [20, 20]
                    ]
                },
                inner: {
                    name: me.Bluaul.Engine.Properties.Comfortable,
                    type: "area",
                    color: "rgb(255, 165, 0)",
                    lineColor: "rgb(255, 165, 0)",
                    data: [
                        [18.5, 37.5],
                        [17.5, 75],
                        [22.5, 65],
                        [24.5, 35],
                        [18.5, 37.5]
                    ]
                }
            },
            "Din1946-2": {
                outer: {
                    name: me.resources.stillComfortable,
                    type: "area",
                    color: "rgb(255, 0, 0)",
                    lineColor: "rgb(255, 0, 0)",
                    data: [
                        [-15, 20],
                        [20, 20],
                        [26, 22],
                        [29, 26],
                        [-15, 26],
                        [-15, 20]
                    ]
                },
                inner: {
                    name: me.Bluaul.Engine.Properties.Comfortable,
                    type: "area",
                    color: "rgb(255, 165, 0)",
                    lineColor: "rgb(255, 165, 0)",
                    data: [
                        [-15, 22],
                        [26, 22],
                        [36, 27],
                        [36, 28.33],
                        [26, 25],
                        [-15, 25],
                        [-15, 22]
                    ]
                }
            }
        };

        me.showInfo("", "", false);

        

        var xAxis_lbl = "";
        var yAxis_lbl = "";
        var xMin, xMax, yMin, yMax;

        switch (me.visual.data("type")) {
            case "Leisden&Freymark":
                xAxis_lbl = me.resources.roomAirTemperature;
                yAxis_lbl = me.resources.relativeAirHumidity;
                xMin = 14;
                xMax = 29;
                yMin = 16;
                yMax = 90;
                break;
            case "Din1946-2":
                xAxis_lbl = me.resources.outerAirTemperature;
                yAxis_lbl = me.resources.roomAirTemperature;
                xMin = -17;
                xMax = 38;
                yMin = 18;
                yMax = 31;
                break;
        default:
        }

        //JS-Event-initialisation && Final DOM-Manipulation
        var DropwonAxisX = me.visual.find(".navigation .x").clone();
        var DropwonAxisY = me.visual.find(".navigation .y").clone();
        var useStandardZoom = me.visual.find(".navigation .check-zoom-container").clone();

        me.visual.find(".navigation .x").replaceWith(
            $("<div>").addClass("x-axis-box vc-grid-2col vc-grid-margin-right")
        );
        me.visual.find(".navigation .y").replaceWith(
            $("<div>").addClass("y-axis-box vc-grid-2col vc-grid-margin-right")
        );
        me.visual.find(".navigation .check-zoom-container").replaceWith(
            $("<div>").addClass("check-zoom-container-box vc-grid-2col vc-grid-margin-right")
        );


        me.visual.find(".navigation .vc-date-box").vcDateBox({
            mode: "Range",
            align: "right",
            interval: 1,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            defaultRange: { from: moment(me.startdate, "DD.MM.YYYY").subtract(7, 'days').toDate(), to: me.startdate },
            langID: me.userLangForCulture,
            callback: function () { }
        });

        me.visual.find(".navigation .x-axis-box").vcOptionBox({
            caption: me.resources.selection,
            items: [{ button: xAxis_lbl, clickable: false, isList: false, content: DropwonAxisX }]
        });
        me.visual.find(".navigation .y-axis-box").vcOptionBox({
            caption: me.resources.selection,
            items: [{ button: yAxis_lbl, clickable: false, isList: false, content: DropwonAxisY }]
        });
        me.visual.find(".navigation .check-zoom-container-box").vcOptionBox({
            caption: me.resources.selection,
            items: [{ button: me.resources.zoom, clickable: false, isList: false, content: useStandardZoom }]
        });

        me.visual.find(".navigation .reload").on("click", function () { me.getChart() });
        me.visual.find(".navigation .zoom").on("click", function () {
            if ($(this).data("zoom-state") === undefined || $(this).data("zoom-state") === 0) {
                $(this).data("zoom-state", 1);
                me.getChart(true);
            } else if ($(this).data("zoom-state") === 1) {
                $(this).data("zoom-state", 0);
                me.getChart();
            } else {
                return false;
            }
            return true;
        });
        me.getChart(); //getChart for first time that no empty display shows
        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};

ComfortChart.prototype.fetch = function () {
    /// <summary>
    /// This function fetches the entry list and copies the default ddls into all entries.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        return true;
    } catch (ex) { me.writeError('fetch', ex); return false; }
}
ComfortChart.prototype.getChart = function () {
    /// <summary>
    /// This function fetches the entry list and copies the default ddls into all entries.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (me.visual.find(".x").children("option:selected").val() !== undefined && me.visual.find(".y").children("option:selected").val() !== undefined) {
            var bsaidX = me.visual.find(".x").children("option:selected").val();
            var bsaidY = me.visual.find(".y").children("option:selected").val();
            var dateRange = me.visual.find(".navigation .vc-date-box").vcDateBox("getDateRange");

            if (moment(dateRange.from, "DD.MM.YYYY").diff(moment(dateRange.to, "DD.MM.YYYY"), "years", true) > 1 || moment(dateRange.from, "DD:MM:YYYY").diff(moment(dateRange.to, "DD:MM:YYYY"), "years", true) < -1) {
                alert(me.resources.errTimeRangeNoLongerThanOneYear);
                return false;
            }

            var chartBorder = {};
            if (me.visual.data("type") in me.CHART_DATA_BORDER) {
                chartBorder = me.CHART_DATA_BORDER[me.visual.data("type")];
            }
            
            var param = {
                "Type": 1,
                "BsaidX": bsaidX,
                "BsaidY": bsaidY,
                "StartDate": dateRange.from,
                "EndDate": dateRange.to
            }
            me.visual.find("#div-chart").html(me.vcC.getLoadingIcon());
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            window.VisualCoreService.getData( me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify(param), function(result) {
                if (result == null) {
                    me.visual.find("#div-chart").html(me.resources.err_loadData);
                    return false;
                } else if (result.length < 1) {
                    me.visual.find("#div-chart").html(me.resources.noEntriesExist);
                    return false;
                }
                

                var xAxis_name = me.visual.find(".x option:selected").html();
                var yAxix_name = me.visual.find(".y option:selected").html();

                var points = {
                    name: xAxis_name + "/ " + yAxix_name,
                    data: []
                };

                if (result.length > 0) {
                    result.forEach(function(p) {
                        points.data.push(
                            {
                                "name": xAxis_name + "/ " + yAxix_name,
                                "timestamp": p.Timestamp,
                                "x": p.ValueX,
                                "y": p.ValueY,
                                "labelX": xAxis_name,
                                "labelY": yAxix_name
                            }
                        );
                    });
                }

                // ReSharper disable once UseOfImplicitGlobalInFunctionScope
                var ro = new RampOptions();
                var chart = ro.getTheme();

                var xAxis_lbl = "";
                var yAxis_lbl = "";

                switch (me.visual.data("type")) {
                case "Leisden&Freymark":
                    xAxis_lbl = me.resources.roomAirTemperature;
                    yAxis_lbl = me.resources.relativeAirHumidity;
                    break;
                case "Din1946-2":
                    xAxis_lbl = me.resources.outerRoomAirTemperature;
                    yAxis_lbl = me.resources.roomAirTemperature;
                    break;
                default:
                }

                chart.chart = {
                    type: "scatter",
                    zoomType: "xy"
                };

                chart.chart.events = {
                    redraw: function () {
                        var legendPointsToColor = $(this.container).find("g.highcharts-legend-item.highcharts-area-series rect.highcharts-point");
                        legendPointsToColor.each(function () {
                            var rgbColorValues = $(this).attr("fill").replace("rgb(", "").replace(")", "").split(","); //remove everything exept numbers, remove the value for opacity, concat afterwards to rgb color
                            if (rgbColorValues.length > 3) {
                                rgbColorValues.pop();
                            }
                                

                            for (var i = 0; i < rgbColorValues.length; i++) {
                                rgbColorValues[i] = rgbColorValues[i].replace(" ", "");
                            }

                            var newColor = "rgb(" + rgbColorValues[0] + ", " + rgbColorValues[1] + ", " + rgbColorValues[2] + ")"; //concat new color without opacity

                            $(this).attr("fill", newColor); //set new color
                        });
                    }
                };
                
                chart.accessibility = {
                    description: ""
                }

                chart.title.text = "";

                chart.subtitle = "";

                chart.xAxis.title.enabled = true;
                chart.xAxis.title.text = xAxis_lbl;
                chart.xAxis.startOnTick = true;
                chart.xAxis.endOnTick = true;
                chart.xAxis.showLastLabel = true;
                chart.yAxis.title.text = yAxis_lbl;

                if (me.visual.find(".navigation .check-zoom-container-box input").is(":checked")) {
                    var xMin, xMax, yMin, yMax;

                    switch (me.visual.data("type")) {
                    case "Leisden&Freymark":
                        xMin = 14;
                        xMax = 29;
                        yMin = 16;
                        yMax = 90;
                        break;
                    case "Din1946-2":
                        xMin = -14;
                        xMax = 36;
                        yMin = 18;
                        yMax = 32;
                        break;
                    default:
                    }

                    chart.xAxis.max = xMax;
                    chart.xAxis.min = xMin;

                    chart.yAxis.max = yMax;
                    chart.yAxis.min = yMin;
                }

                chart.legend.enabled = true;
                chart.plotOptions = {
                    series: {
                        turboThreshold: 0
                    },
                    scatter: {
                        marker: {
                            radius: 2,
                            enabled: true,
                            linecolor: "#000000",
                            linewidth: 1,
                            symbol: "circle",
                            opacity: 1
                        },
                        tooltip: {
                            pointFormat: me.resources.time +
                                ': <b>{point.timestamp}</b><br/>{point.labelX}: <b>{point.x:.2f}</b><br/>{point.labelY}: <b>{point.y:.2f}</b><br/>'
                        }
                    },
                    area: {
                        fillOpacity: 0.1,
                        //backgroundColor: 'transparent',
                        enableMouseTracking: false,
                        marker: {
                            enabled: false
                        }
                    }
                }

                chart.series = [points, chartBorder.outer, chartBorder.inner]; //

                me.container = me.getRandomIDContainerObj("div-chart-", true);
                me.visual.find("#div-chart").html(me.container.obj);

                // ReSharper disable once UseOfImplicitGlobalInFunctionScope
                chart = Highcharts.chart("div-chart-" + me.container.random, chart);

                return true;
            });
        } else {
            return false;
        }

        return true;
    } catch (ex) { me.writeError('fetch', ex); return false }
}